module.exports = "<div class=\"settings-toggle\" (click)=\"openSettings()\">\n  <div class=\"settings-toggle-icon\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/components/settings-toggle/settings-toggle.component.html
// module id = ../../../../../src/app/components/settings-toggle/settings-toggle.component.html
// module chunks = main